<template>
  <section class="body-2">
     <span v-for="(author,index) in   authors" :key="index" class="mx-0 px-0">
        <span v-if="author" :class=" [author.type ? 'indigo--text text--darken-2': 'black--text','font-weight-medium']" v-html="author.name_last"></span>
        <span v-if="author" :class=" [author.type ? 'indigo--text text--darken-2': 'black--text']" v-html ="author.name_first"></span><span v-if="index < authors.length - 1">, </span>
      </span>
    <a v-if="url" :href="url" class="black--text ma-0 pa-0" target="_blanc">
      <div class="font-italic " v-html="title"></div>
    </a>
    <div v-else class="font-italic " v-html ="title"></div>
</section>
</template>
<script>
export default {
  props:['authors','title','url']
}
</script>
